import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import {notificationsRouting} from "./notifications.routing";



@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    notificationsRouting
  ]
})
export class NotificationsModule { }
